import { SettingsTranslationType } from "../../features/settings.types";

export const settings: SettingsTranslationType = {
  settings: {
    title: "设置",
    aiProvider: {
      label: "AI 提供商",
      select: "选择提供商",
      description: "选择用于故事生成的 AI 提供商",
      updateSuccess: "AI 提供商已更新",
      updateSuccessDesc: "您的 AI 提供商首选项已保存",
      updateError: "更新失败",
      updateErrorDesc: "更新 AI 提供商失败。请重试。"
    },
    language: {
      label: "语言",
      description: "选择您偏好的界面语言"
    },
    subscription: {
      title: "订阅",
      currentPlan: "当前计划",
      freeTier: "免费版",
      basicTier: "基础版",
      premiumTier: "高级版",
      status: "状态",
      renewalDate: "续订日期",
      upgradePlan: "升级计划",
      managePlan: "管理订阅",
      cancelPlan: "取消订阅",
      features: "功能",
      billingCycle: "计费周期",
      monthlyLabel: "月付",
      yearlyLabel: "年付",
      priceUnits: {
        month: "月",
        year: "年"
      },
      tiers: {
        free: {
          name: "免费",
          description: "基础功能入门",
          price: "免费"
        },
        basic: {
          name: "基础",
          description: "为业余作家提供的进阶功能",
          price: {
            monthly: "¥69/月",
            yearly: "¥699/年"
          }
        },
        premium: {
          name: "高级",
          description: "为专业作家提供全面访问权限",
          price: {
            monthly: "¥139/月",
            yearly: "¥1399/年"
          }
        }
      },
      browseCharacters: "浏览角色",
      upgradeToBrowse: "升级以浏览您的角色集合",
      upgradeToMakePublic: "升级以公开角色",
      upgradeRequired: "需要升级",
      upgradeToBrowseDescription: "升级您的账户以浏览和重复使用您的角色集合。",
      upgradeToMakePublicDescription: "升级您的账户以便与其他用户公开分享角色。",
      unlockFeatures: "通过订阅解锁高级功能",
      upgradeNow: "立即升级",
      unlockAiTitleGeneration: "解锁AI标题生成",
      upgradeForCharaterAccess: "升级以访问角色管理",
      upgradeForStatsAccess: "升级以访问统计数据和徽章",
      upgradeForAccess: "升级以访问此功能",
      upgradeForAiTitleDescription: "升级到基础版计划，获取AI标题生成功能，并根据您故事的主题、角色和场景获得创意建议。",
      generateTitlesFeature: "即时生成独特标题",
      aiTitleGenerationPremium: "AI标题生成功能在基础版计划中可用",
      unlockGenre: "升级以解锁此类型",
      unlockCustomGenres: "解锁自定义类型",
      upgradeForCustomGenresDescription: "升级到基础版计划，创建自定义类型，使您的故事更加独特。",
      addCustomGenresFeature: "添加无限制的自定义类型",
      unlockEnvironment: "升级以解锁此环境",
      upgradeForCustomEnvironments: "升级到 TaleCraft 基础版以添加自定义环境",
      unlockCustomEnvironments: "解锁自定义环境",
      upgradeForCustomEnvironmentsDescription: "升级到基础版计划，创建自定义环境，使您的故事更加独特。",
      addCustomEnvironmentsFeature: "添加无限制的自定义环境",
      unlockTheme: "升级以解锁此主题",
      upgradeForCustomThemes: "升级到 TaleCraft 基础版以添加自定义主题",
      unlockCustomThemes: "解锁自定义主题",
      upgradeForCustomThemesDescription: "升级到基础版计划，创建自定义主题，使您的故事更加独特。",
      addCustomThemesFeature: "添加无限制的自定义主题",
      unlockStoryLength: "升级以解锁此故事长度",
      upgradeForPremiumLengths: "升级到 TaleCraft 基础版以访问更长的故事",
      unlockPremiumLengths: "解锁高级故事长度",
      upgradeForPremiumLengthsDescription: "升级至高级计划，创作更长的故事并以更丰富的细节发展您的叙事。",
      longStoriesFeature: "创建没有长度限制的故事",
      avatarGenerator: {
        upgradeRequired: "需要升级",
        upgradeDescription: "升级您的帐户以生成角色头像。",
        premiumFeature: "通过高级订阅生成自定义角色头像",
        upgradeNow: "立即升级",
        upgradeTooltip: "升级以生成角色头像"
      },
      planComparison: {
        chooseYourPlan: "选择最适合您需求的计划",
        price: "价格",
        features: "功能",
        talecraftBasic: "TaleCraft 基础版",
        talecraftPremium: "TaleCraft 高级版",
        savePercentage: "节省17%",
        currentPlanLabel: "当前计划：",
        processing: "处理中...",
        downgradeToBasic: "降级至 TaleCraft 基础版",
        downgradeToFree: "降级至免费计划",
        upgradeToBasic: "升级至 TaleCraft 基础版",
        upgradeToPremium: "升级至 TaleCraft 高级版",
        downgradingTo: "降级至",
        effectiveOn: "生效于",
        nextBillingDate: "下一个账单日期",
        featureItems: {
          dailyStoryLimit: "每日故事限制",
          aiStoryGeneration: "AI 故事生成",
          customResponses: "自定义回复",
          aiTitleSuggestion: "AI 标题建议",
          customStorySelection: "自定义故事选择",
          publicSharing: "公开分享",
          characterManagement: "角色管理",
          aiProviderSelection: "AI 提供商选择",
          statsAndBadges: "统计和徽章/排名",
          badgeRewards: "徽章奖励",
          naturalStoryLength: "自然故事长度",
          sequelsAndExtract: "续集和角色提取",
          characterAvatar: "角色头像",
          earlyAccessFeatures: "抢先体验功能"
        },
        limits: {
          perDay: "/天",
          unlimited: "无限制"
        }
      }
    },
    profile: {
      displayName: {
        label: "显示名称",
        placeholder: "输入您的显示名称",
        updateButton: "更新名称",
        helpText: "为您的个人资料选择一个唯一的显示名称"
      },
      inviteFriends: {
        label: "邀请朋友",
        button: "邀请朋友",
        dialogTitle: "分享邀请",
        dialogDescription: "邀请您的朋友加入您的讲故事之旅。分享您独特的邀请链接或使用社交媒体。",
        copySuccess: {
          title: "链接已复制！",
          description: "推荐链接已复制到您的剪贴板。"
        },
        copyFailure: {
          title: "复制失败",
          description: "请尝试手动复制链接。"
        },
        shareMessage: "加入我们的讲故事冒险！一起创作和分享精彩故事。",
        socialPlatforms: {
          facebook: "Facebook",
          X: "X",
          linkedin: "LinkedIn",
        }
      },
      upgradeDialog: {
        title: "需要升级",
        aiProviderDescription: "升级以选择 AI 提供商。",
        unlockProviderSelection: "通过订阅解锁 AI 提供商选择"
      }
    },
    issues: {
      title: "报告问题",
      description: "发现了错误或有建议？请告诉我们！",
      submitSuccess: "问题已报告",
      submitSuccessDesc: "感谢您的反馈。我们将调查此问题。",
      submitError: "提交失败",
      submitErrorDesc: "报告问题时出错。请稍后再试。",
      form: {
        titleLabel: "标题",
        titlePlaceholder: "问题的简要描述",
        descriptionLabel: "描述",
        descriptionPlaceholder: "请提供关于问题的详细信息...",
        priorityLabel: "优先级",
        priorityPlaceholder: "选择优先级",
        priorityLow: "低",
        priorityMedium: "中",
        priorityHigh: "高",
        priorityDescription: "选择此问题的紧急程度，以帮助我们正确地确定优先级。",
        submit: "提交问题",
        submitting: "提交中...",
        imagesLabel: "附加图片",
        typeLabel: "问题类型",
        typePlaceholder: "选择问题类型",
        typeBug: "错误",
        typeRequest: "请求",
        typeDescription: "选择您提交的问题类型",
      },
      imageUpload: {
        dragDrop: "将图片拖放到此处",
        dropHere: "将图片放在这里...",
        clickToSelect: "或单击选择文件",
        maxSize: "最大 5MB",
        maxNumber: "最多 5 张图片",
        attachedImages: "附加图片",
        invalidFiles: "某些文件未被接受",
        sizeTypeLimit: "文件必须是小于 5MB 的图片",
        tooManyImages: "图片过多",
        limitReached: "您最多只能附加 5 张图片",
        pasteSupported: "支持粘贴图片",
        pasteSuccess: "图片已粘贴",
        pasteSuccessDesc: "剪贴板中的图片已附加",
        pasteFailed: "粘贴图片失败",
        pasteFailedDesc: "无法处理剪贴板内容",
        processing: "正在处理图片...",
      },
    }
  }
};